import React, { Component } from "react";
import { connect } from "react-redux";

import SubscriptionHeader from "../SubscriptionHeader";
import SubscriptionsList from "../SubscriptionsList";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import LatestStories from "../../../components/Library/LatestStories";

import { getSubscriptions } from "../../actions/subscriptions";

class Subscriptions extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getSubscriptions({ subscription_type: "newsletter" });
  }

  render() {
    const { subscriptions } = this.props;

    return (
      <Layout includeHeader={true} headerComponent={<SubscriptionHeader/>}>
        <Sidebar>
          <LatestStories/>
        </Sidebar>
        <Content>
          <SubscriptionsList subscriptions={subscriptions}/>
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subscriptions: state.subscriptions,
  };
};

export default connect(mapStateToProps, { getSubscriptions })(Subscriptions);
